import * as React from "react";
const ConvenienceIcon = (props) => (
  <svg
    width={31}
    height={31}
    viewBox="0 0 31 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_2492_12805)">
      <path
        d="M15.4923 0C13.4573 0.000508809 11.4423 0.401832 9.56244 1.18106C7.68255 1.96028 5.97456 3.10214 4.53597 4.54145C3.09738 5.98076 1.95637 7.68932 1.17809 9.56959C0.399807 11.4499 -0.000508451 13.465 4.84662e-07 15.5C-0.000880917 19.2524 1.35949 22.8777 3.82868 25.7032C6.29787 28.5287 9.70821 30.3625 13.4269 30.8644V27.7392C13.4289 27.3092 13.2959 26.8894 13.0467 26.539C12.7975 26.1886 12.4445 25.9253 12.0377 25.7862C9.84167 25.0469 7.93988 23.6242 6.61058 21.7263C5.28128 19.8284 4.59425 17.5549 4.65 15.2384C4.70806 12.3847 5.89246 9.66986 7.94475 7.68617C9.99703 5.70248 12.7506 4.61104 15.6046 4.65C17.0538 4.66553 18.4852 4.97129 19.8142 5.54922C21.1433 6.12714 22.3431 6.96552 23.3427 8.01484C24.3424 9.06415 25.1216 10.3031 25.6345 11.6586C26.1473 13.0141 26.3834 14.4586 26.3287 15.9069L26.3248 15.996C26.319 16.1201 26.3113 16.2441 26.3016 16.368L26.2919 16.4862C26.276 16.6702 26.2547 16.8537 26.2279 17.0364L26.2086 17.1682C24.8814 25.9179 13.4908 30.8353 13.4288 30.8624C15.6185 31.1561 17.8456 30.9781 19.9608 30.3405C22.0761 29.7028 24.0305 28.6203 25.6931 27.1654C27.3557 25.7105 28.688 23.917 29.6006 21.905C30.5132 19.8931 30.985 17.7093 30.9845 15.5C30.985 11.3905 29.3531 7.4491 26.4478 4.5427C23.5425 1.63631 19.6017 0.0029651 15.4923 0.0019375V0Z"
        fill="url(#paint0_linear_2492_12805)"
        fillOpacity={0.7}
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_2492_12805"
        x1={15.4923}
        y1={0}
        x2={15.4923}
        y2={30.9999}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0D7CBB" />
        <stop offset={1} stopColor="#FF00E6" />
      </linearGradient>
      <clipPath id="clip0_2492_12805">
        <rect width={31} height={31} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default ConvenienceIcon;
